module.exports = __webpack_public_path__ + "static/img/04952047.de713376.png";